import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, type OnDestroy, type OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AccessibilityStatementComponent } from '../../../features/accessibility-statement/accessibility-statement.component';
import { ConfigResourceService } from '../../../services/config-resource.service';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-accessibility-statement-modal',
  templateUrl: './accessibility-statement-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ModalComponent, AccessibilityStatementComponent]
})
export class AccessibilityStatementModalComponent implements OnInit, OnDestroy {
  headerText: string = '';
  closeText: string = '';
  private readonly subscriptions = new Subscription();

  constructor(
    private readonly dialogRef: MatDialogRef<AccessibilityStatementComponent>,
    private readonly configService: ConfigResourceService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.configService.configLoaded$.subscribe({
        next: loaded => {
          if (loaded) {
            this.headerText = this.configService.getProcessedResourceValue<string>('Spa_Site_Accessibility', 'Accessibility statement');
            this.closeText = this.configService.getProcessedResourceValue<string>('DC5_Close_Text', 'Close');
            this.cdr.markForCheck();
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  closeModal(): void {
    this.dialogRef.close();
  }
}
